document.querySelectorAll('.faq-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('is-open');

    document.querySelectorAll('.faq-item.is-open').forEach(el => {
      el.classList.remove('is-open');
      el.querySelector('.faq-btn').setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');

      setTimeout(() => {
        const offset = 100;
        const itemTop = item.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: itemTop - offset,
          behavior: 'smooth'
        });
      }, 400);
    }
  });
});